
const products = [
    {
        ID: "1",
        name: "Preguntas Frecuentes"
    }, {
        ID: "1_1",
        categoryId: "1",
        name: "¿Cómo registrarse?"
    }, {
        ID: "1_1_1",
        categoryId: "1_1",
        name: "App"
    }, {
        ID: "1_1_1_1",
        categoryId: "1_1_1",
        name: "",
        video: "https://youtu.be/Gt6uT_eRj0A?si=LmMdRZ1yiLM-hYz9",
    }, 
    {
        ID: "1_1_2",
        categoryId: "1_1",
        name: "Web"
    }, {
        ID: "1_1_2_1",
        categoryId: "1_1_2",
        name: "Hola",
        video: "https://youtu.be/Gt6uT_eRj0A?si=LmMdRZ1yiLM-hYz9",
    },  
    {
        ID: "1_2",
        categoryId: "1",
        name: "¿Cómo iniciar tu jornada laboral?"
    }, {
        ID: "1_2_1",
        categoryId: "1_2",
        name: "App"
    }, {
        ID: "1_2_1_1",
        categoryId: "1_2_1",
        name: "",
        video: "https://youtu.be/q7WYSRzaPIA?si=J34430jNVagMxrOo"
    }, 
    {
        ID: "1_2_2",
        categoryId: "1_2",
        name: "Web"
    }, {
        ID: "1_2_2_1",
        categoryId: "1_2_2",
        name: "",
        video: "https://youtu.be/q7WYSRzaPIA?si=J34430jNVagMxrOo"
    },
    {
        ID: "1_3",
        categoryId: "1",
        name: "¿Cómo iniciar tu jornada laboral?"
    }, {
        ID: "1_3_1",
        categoryId: "1_3",
        name: "App"
    }, {
        ID: "1_3_1_1",
        categoryId: "1_3_1",
        name: "",
        video: "https://youtu.be/q7WYSRzaPIA?si=J34430jNVagMxrOo"
    }, 
    {
        ID: "1_3_2",
        categoryId: "1_3",
        name: "Web"
    }, {
        ID: "1_3_2_1",
        categoryId: "1_3_2",
        name: "",
        video: "https://youtu.be/q7WYSRzaPIA?si=J34430jNVagMxrOo"
    },    
];

export default products;